import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { ShippingMethodCode } from '../../../shared/enums';
import { ShippingMethodPropertyResponse } from '../../../shared/api/responses';

@jsonObject
export class PublicSubscriptionShippingMethodCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly category!: string;

  @jsonMember(String)
  public readonly description!: string;

  @jsonMember(String)
  public readonly code!: ShippingMethodCode;

  @jsonMember(Number)
  public readonly shippingPrice!: number;

  @jsonMember(Number)
  public readonly totalPrice!: number;

  @jsonArrayMember(ShippingMethodPropertyResponse)
  public readonly properties!: ShippingMethodPropertyResponse[];
}
